export default "__VITE_ASSET__163545e1__"